// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  ActivateTurboData,
  ActivateTurboErrors,
  ActivateTurboResponses,
  AdminActivityActionsData,
  AdminActivityActionsResponses,
  AdminActivityAnalyticsData,
  AdminActivityAnalyticsErrors,
  AdminActivityAnalyticsResponses,
  AdminArchiveHouseholdData,
  AdminArchiveHouseholdErrors,
  AdminArchiveHouseholdResponses,
  AdminCheckHubData,
  AdminCheckHubErrors,
  AdminCheckHubResponses,
  AdminCreateHouseholdData,
  AdminCreateHouseholdErrors,
  AdminCreateHouseholdResponses,
  AdminCreateWifiLinkData,
  AdminCreateWifiLinkErrors,
  AdminCreateWifiLinkResponses,
  AdminDeleteHaTokenData,
  AdminDeleteHaTokenErrors,
  AdminDeleteHaTokenResponses,
  AdminDeleteHouseholdDocumentData,
  AdminDeleteHouseholdDocumentErrors,
  AdminDeleteHouseholdDocumentResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserResponses,
  AdminDeleteWifiPasswordData,
  AdminDeleteWifiPasswordErrors,
  AdminDeleteWifiPasswordResponses,
  AdminExportHouseholdData,
  AdminExportHouseholdErrors,
  AdminExportHouseholdResponses,
  AdminGetHouseholdData,
  AdminGetHouseholdErrors,
  AdminGetHouseholdResponses,
  AdminGetUserData,
  AdminGetUserErrors,
  AdminGetUserResponses,
  AdminGetWifiLinkData,
  AdminGetWifiLinkErrors,
  AdminGetWifiLinkResponses,
  AdminHeatingGroupsData,
  AdminHeatingGroupsErrors,
  AdminHeatingGroupsResponses,
  AdminImportHouseholdData,
  AdminImportHouseholdErrors,
  AdminImportHouseholdResponses,
  AdminInviteUserData,
  AdminInviteUserErrors,
  AdminInviteUserResponses,
  AdminListActivityData,
  AdminListActivityErrors,
  AdminListActivityResponses,
  AdminListHouseholdsData,
  AdminListHouseholdsErrors,
  AdminListHouseholdsResponses,
  AdminListUsersData,
  AdminListUsersResponses,
  AdminRegenerateAccessCodeData,
  AdminRegenerateAccessCodeErrors,
  AdminRegenerateAccessCodeResponses,
  AdminResetOnboardingData,
  AdminResetOnboardingErrors,
  AdminResetOnboardingResponses,
  AdminRevealHouseholdSecretsData,
  AdminRevealHouseholdSecretsErrors,
  AdminRevealHouseholdSecretsResponses,
  AdminRevokeWifiLinkData,
  AdminRevokeWifiLinkErrors,
  AdminRevokeWifiLinkResponses,
  AdminUnarchiveHouseholdData,
  AdminUnarchiveHouseholdErrors,
  AdminUnarchiveHouseholdResponses,
  AdminUpdateHouseholdData,
  AdminUpdateHouseholdErrors,
  AdminUpdateHouseholdResponses,
  AdminUpdatePreconfigData,
  AdminUpdatePreconfigErrors,
  AdminUpdatePreconfigResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  AdminUploadHouseholdDocumentData,
  AdminUploadHouseholdDocumentErrors,
  AdminUploadHouseholdDocumentResponses,
  ApplyHeatingMappingData,
  ApplyHeatingMappingErrors,
  ApplyHeatingMappingResponses,
  ApplyWindowMappingData,
  ApplyWindowMappingErrors,
  ApplyWindowMappingResponses,
  AskAssistantData,
  AskAssistantErrors,
  AskAssistantResponses,
  ChangePasswordData,
  ChangePasswordErrors,
  ChangePasswordResponses,
  CompleteOnboardingStepData,
  CompleteOnboardingStepErrors,
  CompleteOnboardingStepResponses,
  ConfirmWifiLinkData,
  ConfirmWifiLinkErrors,
  ConfirmWifiLinkResponses,
  DiagnoseGatewaysData,
  DiagnoseGatewaysResponses,
  FireHeatingZoneData,
  FireHeatingZoneErrors,
  FireHeatingZoneResponses,
  GetActivityData,
  GetActivityResponses,
  GetAirthingsStatusData,
  GetAirthingsStatusResponses,
  GetAssistantConversationData,
  GetAssistantConversationErrors,
  GetAssistantConversationResponses,
  GetHealthData,
  GetHealthResponses,
  GetHubStatusData,
  GetHubStatusResponses,
  GetMeData,
  GetMeDetailData,
  GetMeDetailResponses,
  GetMeResponses,
  GetOnboardingHouseholdData,
  GetOnboardingHouseholdResponses,
  GetOnboardingStateData,
  GetOnboardingStateResponses,
  GetVentilationStateData,
  GetVentilationStateResponses,
  GetWifiLinkData,
  GetWifiLinkErrors,
  GetWifiLinkResponses,
  GetWindowsStatusData,
  GetWindowsStatusResponses,
  ListAirSensorsData,
  ListAirSensorsResponses,
  ListGatewaysData,
  ListGatewaysResponses,
  ListHeatingZonesData,
  ListHeatingZonesResponses,
  ListIssuesData,
  ListIssuesResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  LoginWithCodeData,
  LoginWithCodeErrors,
  LoginWithCodeResponses,
  LogoutData,
  LogoutResponses,
  MergeHeatingRoomsData,
  MergeHeatingRoomsErrors,
  MergeHeatingRoomsResponses,
  ProvisionGatewayData,
  ProvisionGatewayErrors,
  ProvisionGatewayResponses,
  RecordIssueData,
  RecordIssueErrors,
  RecordIssueResponses,
  RequestOnboardingLinkData,
  RequestOnboardingLinkErrors,
  RequestOnboardingLinkResponses,
  RescanWindowsData,
  RescanWindowsResponses,
  SendDueIssueReportsData,
  SendDueIssueReportsErrors,
  SendDueIssueReportsResponses,
  SendIssueReportData,
  SendIssueReportResponses,
  SetWindowPositionData,
  SetWindowPositionErrors,
  SetWindowPositionResponses,
  SignupData,
  SignupErrors,
  SignupResponses,
  SkipOnboardingStepData,
  SkipOnboardingStepErrors,
  SkipOnboardingStepResponses,
  SubmitWifiLinkData,
  SubmitWifiLinkErrors,
  SubmitWifiLinkResponses,
  UpdateProfileData,
  UpdateProfileErrors,
  UpdateProfileResponses,
  UploadAssistantPhotoData,
  UploadAssistantPhotoErrors,
  UploadAssistantPhotoResponses,
  VerifyAirSensorPlacementData,
  VerifyAirSensorPlacementErrors,
  VerifyAirSensorPlacementResponses,
  VerifyOnboardingLinkData,
  VerifyOnboardingLinkErrors,
  VerifyOnboardingLinkResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
): RequestResult<GetHealthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Auth Signup
 *
 * Register a new user with email verification.
 */
export const signup = <ThrowOnError extends boolean = false>(
  options: Options<SignupData, ThrowOnError>,
): RequestResult<SignupResponses, SignupErrors, ThrowOnError> =>
  (options.client ?? client).post<SignupResponses, SignupErrors, ThrowOnError>({
    url: "/auth/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Login
 *
 * Authenticate via Supabase, then set the signed session cookie.
 *
 * The Supabase access/refresh tokens never leave the backend — the browser
 * only ever sees the HMAC cookie this endpoint sets.
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>,
): RequestResult<LoginResponses, LoginErrors, ThrowOnError> =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: "/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Me
 *
 * Get the current user's profile.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
): RequestResult<GetMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });

/**
 * Auth Me Detail
 *
 * Get the current user's profile with timeline fields.
 */
export const getMeDetail = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeDetailData, ThrowOnError>,
): RequestResult<GetMeDetailResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetMeDetailResponses, unknown, ThrowOnError>({
    url: "/auth/me/detail",
    ...options,
  });

/**
 * Auth Update Profile
 *
 * Update current user's name.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProfileData, ThrowOnError>,
): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    url: "/auth/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Change Password
 *
 * Change the current user's password (verifies current password first).
 */
export const changePassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordData, ThrowOnError>,
): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> =>
  (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    url: "/auth/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Activity
 *
 * Get the current user's activity log.
 */
export const getActivity = <ThrowOnError extends boolean = false>(
  options?: Options<GetActivityData, ThrowOnError>,
): RequestResult<GetActivityResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetActivityResponses, unknown, ThrowOnError>({
    url: "/auth/activity",
    ...options,
  });

/**
 * Onboarding Request Link
 *
 * Check the email against pre-provisioned households; send a magic link on match.
 *
 * Households are the allowlist — no account is created for unknown emails.
 */
export const requestOnboardingLink = <ThrowOnError extends boolean = false>(
  options: Options<RequestOnboardingLinkData, ThrowOnError>,
): RequestResult<RequestOnboardingLinkResponses, RequestOnboardingLinkErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RequestOnboardingLinkResponses,
    RequestOnboardingLinkErrors,
    ThrowOnError
  >({
    url: "/auth/onboarding/request-link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Verify
 *
 * Verify a magic-link token server-side, attach the household, set the cookie.
 *
 * Browser-navigated (not SDK-called): always redirects back into the SPA.
 * Supabase tokens never reach the browser — only the HMAC session cookie.
 */
export const verifyOnboardingLink = <ThrowOnError extends boolean = false>(
  options: Options<VerifyOnboardingLinkData, ThrowOnError>,
): RequestResult<VerifyOnboardingLinkResponses, VerifyOnboardingLinkErrors, ThrowOnError> =>
  (options.client ?? client).get<
    VerifyOnboardingLinkResponses,
    VerifyOnboardingLinkErrors,
    ThrowOnError
  >({ url: "/auth/onboarding/verify", ...options });

/**
 * Onboarding Login With Code
 *
 * Log a household in with its admin-issued 6-digit access code.
 *
 * The code alone identifies the household; on success we set the same HMAC
 * session cookie the magic-link path uses, keyed to the contact email. No
 * Supabase auth user is required — the onboarding flow keys off the email.
 */
export const loginWithCode = <ThrowOnError extends boolean = false>(
  options: Options<LoginWithCodeData, ThrowOnError>,
): RequestResult<LoginWithCodeResponses, LoginWithCodeErrors, ThrowOnError> =>
  (options.client ?? client).post<LoginWithCodeResponses, LoginWithCodeErrors, ThrowOnError>({
    url: "/auth/onboarding/code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Wifi Link
 *
 * Resolve a sharing link for the household that opened it.
 *
 * Unauthenticated and scoped to the token. Returns a masked hint so the
 * visitor can tell the link is meant for them without the page disclosing
 * the household's email address or surname to a stranger holding the URL.
 */
export const getWifiLink = <ThrowOnError extends boolean = false>(
  options: Options<GetWifiLinkData, ThrowOnError>,
): RequestResult<GetWifiLinkResponses, GetWifiLinkErrors, ThrowOnError> =>
  (options.client ?? client).get<GetWifiLinkResponses, GetWifiLinkErrors, ThrowOnError>({
    url: "/wifi-link/{token}",
    ...options,
  });

/**
 * Confirm Wifi Link
 *
 * Check an identity answer so the page can advance to the form.
 *
 * Grants nothing: no token, no cookie, no server-side session. Submit
 * re-validates independently, so this endpoint is a convenience that saves
 * the household filling in the whole form before learning they mistyped.
 * Both endpoints charge the same attempt counter, so skipping this step
 * buys no extra guesses.
 */
export const confirmWifiLink = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmWifiLinkData, ThrowOnError>,
): RequestResult<ConfirmWifiLinkResponses, ConfirmWifiLinkErrors, ThrowOnError> =>
  (options.client ?? client).post<ConfirmWifiLinkResponses, ConfirmWifiLinkErrors, ThrowOnError>({
    url: "/wifi-link/{token}/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Submit Wifi Link
 *
 * Store a household's Wi-Fi credentials and burn the link.
 *
 * Writes the non-secret parts into the existing `preconfig` jsonb and the
 * password into the existing write-only column, so `preconfig_ready` flips
 * exactly as it does when an admin types them in by hand.
 */
export const submitWifiLink = <ThrowOnError extends boolean = false>(
  options: Options<SubmitWifiLinkData, ThrowOnError>,
): RequestResult<SubmitWifiLinkResponses, SubmitWifiLinkErrors, ThrowOnError> =>
  (options.client ?? client).post<SubmitWifiLinkResponses, SubmitWifiLinkErrors, ThrowOnError>({
    url: "/wifi-link/{token}/submit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding State
 *
 * Flow steps with statuses and the resume point for the current household.
 */
export const getOnboardingState = <ThrowOnError extends boolean = false>(
  options?: Options<GetOnboardingStateData, ThrowOnError>,
): RequestResult<GetOnboardingStateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetOnboardingStateResponses, unknown, ThrowOnError>({
    url: "/onboarding/state",
    ...options,
  });

/**
 * Onboarding Complete Step
 *
 * Mark a step completed (upsert) and return the fresh state.
 *
 * Completing the final remaining step ends the flow: the household flips to
 * 'ready_for_handoff' (unless something was skipped, in which case it already
 * reads 'support_needed') and any issue report it
 * has been holding goes out, in the background so this response does not
 * wait on it.
 */
export const completeOnboardingStep = <ThrowOnError extends boolean = false>(
  options: Options<CompleteOnboardingStepData, ThrowOnError>,
): RequestResult<CompleteOnboardingStepResponses, CompleteOnboardingStepErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CompleteOnboardingStepResponses,
    CompleteOnboardingStepErrors,
    ThrowOnError
  >({
    url: "/onboarding/steps/{step_key}/complete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Skip Step
 *
 * Mark a step skipped so a household blocked on it can carry on.
 *
 * A module whose hardware cannot be reached (an integration missing from the
 * hub, a gateway that never provisions) otherwise dead-ends the whole flow:
 * every later compartment sits behind a step that can never succeed. Skipping
 * is already a first-class status — it satisfies `resume_step_key` but is
 * deliberately excluded from the closing recap, so nothing claims credit for
 * hardware still in the box.
 *
 * `reason` is stored on the progress row: a skip is a support signal, and
 * knowing which failure caused it is the point of recording it at all.
 *
 * Skipping the last open step ends the flow, so this is also where the held
 * issue report goes out for the households that need it most: one that
 * skipped a connector it could not get working holds at 'shipped' and never
 * reaches handoff, but its problems are exactly what the report is for.
 */
export const skipOnboardingStep = <ThrowOnError extends boolean = false>(
  options: Options<SkipOnboardingStepData, ThrowOnError>,
): RequestResult<SkipOnboardingStepResponses, SkipOnboardingStepErrors, ThrowOnError> =>
  (options.client ?? client).post<
    SkipOnboardingStepResponses,
    SkipOnboardingStepErrors,
    ThrowOnError
  >({
    url: "/onboarding/steps/{step_key}/skip",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Household
 *
 * Household data (measurements, links, documents) for display in steps.
 */
export const getOnboardingHousehold = <ThrowOnError extends boolean = false>(
  options?: Options<GetOnboardingHouseholdData, ThrowOnError>,
): RequestResult<GetOnboardingHouseholdResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetOnboardingHouseholdResponses, unknown, ThrowOnError>({
    url: "/onboarding/household",
    ...options,
  });

/**
 * Verify Air Sensor Placement
 *
 * Check an air-sensor placement photo with the OpenAI vision model.
 */
export const verifyAirSensorPlacement = <ThrowOnError extends boolean = false>(
  options: Options<VerifyAirSensorPlacementData, ThrowOnError>,
): RequestResult<VerifyAirSensorPlacementResponses, VerifyAirSensorPlacementErrors, ThrowOnError> =>
  (options.client ?? client).post<
    VerifyAirSensorPlacementResponses,
    VerifyAirSensorPlacementErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/onboarding/air-sensors/verify-placement",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Admin List Users
 *
 * List all users (admin only).
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListUsersData, ThrowOnError>,
): RequestResult<AdminListUsersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminListUsersResponses, unknown, ThrowOnError>({
    url: "/admin/users",
    ...options,
  });

/**
 * Admin Delete User
 *
 * Delete a user (admin only). Self-deletion blocked.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
): RequestResult<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Get User
 *
 * Get a single user detail with activity logs (admin only).
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetUserData, ThrowOnError>,
): RequestResult<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Update User
 *
 * Update a user's name or role (admin only). Self-demotion blocked.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Invite User
 *
 * Invite a user by email (admin only).
 */
export const adminInviteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminInviteUserData, ThrowOnError>,
): RequestResult<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError> =>
  (options.client ?? client).post<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError>({
    url: "/admin/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Activity
 *
 * List activity across all users (admin only).
 *
 * Search, filtering, sorting, and pagination are all applied server-side by
 * the list_recent_activity RPC — the client sends params and renders results.
 */
export const adminListActivity = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListActivityData, ThrowOnError>,
): RequestResult<AdminListActivityResponses, AdminListActivityErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminListActivityResponses,
    AdminListActivityErrors,
    ThrowOnError
  >({ url: "/admin/activity", ...options });

/**
 * Admin Activity Analytics
 *
 * Aggregated activity analytics for the admin dashboard (admin only).
 */
export const adminActivityAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityAnalyticsData, ThrowOnError>,
): RequestResult<AdminActivityAnalyticsResponses, AdminActivityAnalyticsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminActivityAnalyticsResponses,
    AdminActivityAnalyticsErrors,
    ThrowOnError
  >({ url: "/admin/activity/analytics", ...options });

/**
 * Admin Activity Actions
 *
 * Distinct activity actions across all time (admin only).
 *
 * Used to populate the activity filter dropdown so it matches the full,
 * unbounded table scope rather than the windowed analytics breakdown.
 */
export const adminActivityActions = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityActionsData, ThrowOnError>,
): RequestResult<AdminActivityActionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminActivityActionsResponses, unknown, ThrowOnError>({
    url: "/admin/activity/actions",
    ...options,
  });

/**
 * Admin List Households
 *
 * List households with onboarding progress counts (admin only).
 *
 * By default only active (non-archived) households are returned. Pass
 * ``archived=true`` to list only archived households instead.
 */
export const adminListHouseholds = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListHouseholdsData, ThrowOnError>,
): RequestResult<AdminListHouseholdsResponses, AdminListHouseholdsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminListHouseholdsResponses,
    AdminListHouseholdsErrors,
    ThrowOnError
  >({ url: "/admin/households", ...options });

/**
 * Admin Create Household
 *
 * Create a pre-provisioned household (admin only).
 */
export const adminCreateHousehold = <ThrowOnError extends boolean = false>(
  options: Options<AdminCreateHouseholdData, ThrowOnError>,
): RequestResult<AdminCreateHouseholdResponses, AdminCreateHouseholdErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminCreateHouseholdResponses,
    AdminCreateHouseholdErrors,
    ThrowOnError
  >({
    url: "/admin/households",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Import Household
 *
 * Create a household from a setupData JSON export (admin only).
 *
 * Parses the payload into the internal shape (applying blank-room discard,
 * electric split, and house-level ventilation) and reuses the create path.
 */
export const adminImportHousehold = <ThrowOnError extends boolean = false>(
  options: Options<AdminImportHouseholdData, ThrowOnError>,
): RequestResult<AdminImportHouseholdResponses, AdminImportHouseholdErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminImportHouseholdResponses,
    AdminImportHouseholdErrors,
    ThrowOnError
  >({
    url: "/admin/households/import",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Get Household
 *
 * Get a single household's full detail (admin only).
 */
export const adminGetHousehold = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetHouseholdData, ThrowOnError>,
): RequestResult<AdminGetHouseholdResponses, AdminGetHouseholdErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetHouseholdResponses, AdminGetHouseholdErrors, ThrowOnError>(
    { url: "/admin/households/{household_id}", ...options },
  );

/**
 * Admin Update Household
 *
 * Partially update a household (admin only).
 *
 * ha_token is write-only: an empty string means "keep the existing token",
 * and the stored value is never echoed back or logged.
 */
export const adminUpdateHousehold = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateHouseholdData, ThrowOnError>,
): RequestResult<AdminUpdateHouseholdResponses, AdminUpdateHouseholdErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminUpdateHouseholdResponses,
    AdminUpdateHouseholdErrors,
    ThrowOnError
  >({
    url: "/admin/households/{household_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Reveal Household Secrets
 *
 * Reveal a household's stored plaintext secrets (admin only).
 *
 * Every other admin read exposes these as `has_*` booleans; this endpoint
 * deliberately returns the actual stored values (approved) so an admin can
 * retrieve them for on-site setup. Each field is null when unset. 404 if the
 * household doesn't exist.
 */
export const adminRevealHouseholdSecrets = <ThrowOnError extends boolean = false>(
  options: Options<AdminRevealHouseholdSecretsData, ThrowOnError>,
): RequestResult<
  AdminRevealHouseholdSecretsResponses,
  AdminRevealHouseholdSecretsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminRevealHouseholdSecretsResponses,
    AdminRevealHouseholdSecretsErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/secrets", ...options });

/**
 * Admin Revoke Wifi Link
 *
 * Kill any outstanding sharing link for a household.
 */
export const adminRevokeWifiLink = <ThrowOnError extends boolean = false>(
  options: Options<AdminRevokeWifiLinkData, ThrowOnError>,
): RequestResult<AdminRevokeWifiLinkResponses, AdminRevokeWifiLinkErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminRevokeWifiLinkResponses,
    AdminRevokeWifiLinkErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/wifi-link", ...options });

/**
 * Admin Get Wifi Link
 *
 * The household's most recent sharing link, or null if none was issued.
 *
 * Carries no token: the raw value left the building at creation time.
 */
export const adminGetWifiLink = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetWifiLinkData, ThrowOnError>,
): RequestResult<AdminGetWifiLinkResponses, AdminGetWifiLinkErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetWifiLinkResponses, AdminGetWifiLinkErrors, ThrowOnError>({
    url: "/admin/households/{household_id}/wifi-link",
    ...options,
  });

/**
 * Admin Create Wifi Link
 *
 * Issue a Wi-Fi credential sharing link for a household.
 *
 * The URL is returned once and is not retrievable afterwards, because only
 * the token's hash is stored. If it is lost, issue a new one: creating a
 * link revokes any link still outstanding, so only one is ever live.
 */
export const adminCreateWifiLink = <ThrowOnError extends boolean = false>(
  options: Options<AdminCreateWifiLinkData, ThrowOnError>,
): RequestResult<AdminCreateWifiLinkResponses, AdminCreateWifiLinkErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminCreateWifiLinkResponses,
    AdminCreateWifiLinkErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/wifi-link", ...options });

/**
 * Admin Delete Wifi Password
 *
 * Delete a household's stored Wi-Fi password once setup is confirmed.
 *
 * This is the action that makes the sharing page's retention promise true,
 * so it has to exist as its own endpoint: `admin_update_preconfig` gates on
 * `if body.wifi_password:`, a truthy check, so an empty string cannot clear
 * the column.
 *
 * The SSID in `preconfig` is left alone. It is not a secret, and support
 * still needs to know which network the kit was configured for.
 */
export const adminDeleteWifiPassword = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteWifiPasswordData, ThrowOnError>,
): RequestResult<AdminDeleteWifiPasswordResponses, AdminDeleteWifiPasswordErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteWifiPasswordResponses,
    AdminDeleteWifiPasswordErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/wifi-password", ...options });

/**
 * Admin Delete Ha Token
 *
 * Take the hub token off a household (admin only).
 *
 * Its own endpoint for the same reason the Wi-Fi password has one: an empty
 * token field means "keep the one you have", which is what you want for a
 * field nobody should wipe by tabbing through it, and it leaves no way to get
 * a wrong token off a record. Beta Test House 14 sat behind that for weeks.
 *
 * The URL is left alone. It is not the thing that was wrong.
 */
export const adminDeleteHaToken = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteHaTokenData, ThrowOnError>,
): RequestResult<AdminDeleteHaTokenResponses, AdminDeleteHaTokenErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteHaTokenResponses,
    AdminDeleteHaTokenErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/ha-token", ...options });

/**
 * Admin Heating Groups
 *
 * Which circuits share a thermostat on this household's Wavin.
 *
 * Read live rather than from a stored snapshot. The grouping changes whenever
 * someone re-scans or re-pairs, and a stale card saying a house is fine when
 * it is not would be worse than no card at all.
 *
 * Never raises on a hub problem: it answers `available=False` with a reason,
 * because "we could not look" and "we looked and there is nothing" send
 * support to different places, and the second must not be implied by the
 * first.
 */
export const adminHeatingGroups = <ThrowOnError extends boolean = false>(
  options: Options<AdminHeatingGroupsData, ThrowOnError>,
): RequestResult<AdminHeatingGroupsResponses, AdminHeatingGroupsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AdminHeatingGroupsResponses,
    AdminHeatingGroupsErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/heating-groups", ...options });

/**
 * Admin Check Hub
 *
 * Call this household's hub with the token on record and report what it said.
 *
 * Read live, and never raise: a household page must open for a house whose
 * hub is switched off. The three outcomes are kept apart because they send
 * support to different places. A refused token is a record to correct from a
 * desk. A silent hub may be a visit.
 */
export const adminCheckHub = <ThrowOnError extends boolean = false>(
  options: Options<AdminCheckHubData, ThrowOnError>,
): RequestResult<AdminCheckHubResponses, AdminCheckHubErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminCheckHubResponses, AdminCheckHubErrors, ThrowOnError>({
    url: "/admin/households/{household_id}/hub-check",
    ...options,
  });

/**
 * Admin Export Household
 *
 * Return the setupData JSON handoff payload for a household (admin only).
 */
export const adminExportHousehold = <ThrowOnError extends boolean = false>(
  options: Options<AdminExportHouseholdData, ThrowOnError>,
): RequestResult<AdminExportHouseholdResponses, AdminExportHouseholdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AdminExportHouseholdResponses,
    AdminExportHouseholdErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/export", ...options });

/**
 * Admin Regenerate Access Code
 *
 * Issue a fresh 6-digit access code for a household (admin only).
 */
export const adminRegenerateAccessCode = <ThrowOnError extends boolean = false>(
  options: Options<AdminRegenerateAccessCodeData, ThrowOnError>,
): RequestResult<
  AdminRegenerateAccessCodeResponses,
  AdminRegenerateAccessCodeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminRegenerateAccessCodeResponses,
    AdminRegenerateAccessCodeErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/access-code", ...options });

/**
 * Admin Archive Household
 *
 * Archive a household so it drops off the default list (admin only).
 *
 * Soft and reversible: sets ``archived_at`` to the current UTC timestamp. A
 * 404 is returned when the household doesn't exist.
 */
export const adminArchiveHousehold = <ThrowOnError extends boolean = false>(
  options: Options<AdminArchiveHouseholdData, ThrowOnError>,
): RequestResult<AdminArchiveHouseholdResponses, AdminArchiveHouseholdErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminArchiveHouseholdResponses,
    AdminArchiveHouseholdErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/archive", ...options });

/**
 * Admin Unarchive Household
 *
 * Restore an archived household back to the default list (admin only).
 *
 * Clears ``archived_at`` (sets it to null). A 404 is returned when the
 * household doesn't exist.
 */
export const adminUnarchiveHousehold = <ThrowOnError extends boolean = false>(
  options: Options<AdminUnarchiveHouseholdData, ThrowOnError>,
): RequestResult<AdminUnarchiveHouseholdResponses, AdminUnarchiveHouseholdErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminUnarchiveHouseholdResponses,
    AdminUnarchiveHouseholdErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/unarchive", ...options });

/**
 * Admin Reset Onboarding
 *
 * Reset a household's onboarding progress so the flow can be re-walked (admin only).
 *
 * Deletes every onboarding_progress row for the household and, when the home
 * had already been handed off ('ready_for_handoff'), rolls its status back to
 * 'shipped' so the resume point falls to the first step again. Any earlier
 * fulfillment status is left untouched. Preconfig, secrets, rooms, devices,
 * documents, access_code, and user_id are all left intact — only progress rows
 * and the status field are touched.
 */
export const adminResetOnboarding = <ThrowOnError extends boolean = false>(
  options: Options<AdminResetOnboardingData, ThrowOnError>,
): RequestResult<AdminResetOnboardingResponses, AdminResetOnboardingErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminResetOnboardingResponses,
    AdminResetOnboardingErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/reset-onboarding", ...options });

/**
 * Admin Update Preconfig
 *
 * Partially update a household's pre-ship configuration (admin only).
 *
 * wifi_password, ha_login_password, and velux_klg_password are write-only,
 * mirroring ha_token: an empty string (or omission) means "keep the
 * existing secret", and the stored values are never echoed back or
 * logged. Gateway/VELUX MAC addresses are normalized and validated before
 * being stored.
 */
export const adminUpdatePreconfig = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdatePreconfigData, ThrowOnError>,
): RequestResult<AdminUpdatePreconfigResponses, AdminUpdatePreconfigErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminUpdatePreconfigResponses,
    AdminUpdatePreconfigErrors,
    ThrowOnError
  >({
    url: "/admin/households/{household_id}/preconfig",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding List Gateways
 *
 * List the usr_provision gateway entries on the household's Home Assistant.
 *
 * Lets a flow screen show which gateways (MACs) are already provisioned and
 * whether their entries are loaded — e.g. to poll until a gateway comes up.
 */
export const listGateways = <ThrowOnError extends boolean = false>(
  options?: Options<ListGatewaysData, ThrowOnError>,
): RequestResult<ListGatewaysResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListGatewaysResponses, unknown, ThrowOnError>({
    url: "/onboarding/gateways",
    ...options,
  });

/**
 * Onboarding Diagnose Gateways
 *
 * Say which fault the gateways have, instead of "they did not answer".
 *
 * Read-only. Called when a gateway step fails, so the screen can put one
 * action in front of the resident and route the rest to support.
 *
 * Both gateways in one call, because two of the readings only exist across the
 * pair: both never joining points at one procedure applied twice rather than
 * two faults, and both being reachable yet silent is what a swapped pair looks
 * like. A per-gateway endpoint could not see either.
 *
 * The entity registry is read over the WebSocket because that is the only
 * place entity ownership survives a rename. It degrades rather than failing:
 * without it reachability is reported unknown, which is the honest answer.
 */
export const diagnoseGateways = <ThrowOnError extends boolean = false>(
  options?: Options<DiagnoseGatewaysData, ThrowOnError>,
): RequestResult<DiagnoseGatewaysResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<DiagnoseGatewaysResponses, unknown, ThrowOnError>({
    url: "/onboarding/gateways/diagnosis",
    ...options,
  });

/**
 * Onboarding Provision Gateway
 *
 * Register a USR gateway with the household's Home Assistant.
 *
 * Called by the floor-heating (wavin) and ventilation (nilan) flow steps.
 * The MAC comes from the request or falls back to the one stored in the
 * household's pre-configuration (admin-filled before the kit ships). On
 * success, an explicitly supplied MAC is written back to preconfig so
 * later runs can omit it.
 */
export const provisionGateway = <ThrowOnError extends boolean = false>(
  options: Options<ProvisionGatewayData, ThrowOnError>,
): RequestResult<ProvisionGatewayResponses, ProvisionGatewayErrors, ThrowOnError> =>
  (options.client ?? client).post<ProvisionGatewayResponses, ProvisionGatewayErrors, ThrowOnError>({
    url: "/onboarding/gateways/provision",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Hub Status
 *
 * Check the household's Smart Hub is reachable (home_assistant step).
 *
 * Returns reachable=false with a detail (rather than an error status) so the
 * screen can poll this while the hub boots.
 */
export const getHubStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetHubStatusData, ThrowOnError>,
): RequestResult<GetHubStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHubStatusResponses, unknown, ThrowOnError>({
    url: "/onboarding/ha/status",
    ...options,
  });

/**
 * Onboarding Heating Zones
 *
 * The Wavin zones on the hub with temperatures and live valve state.
 *
 * The floor-heating step polls this during circuit identification: turning a
 * room thermostat up opens that zone's valve, revealing which circuit it is.
 */
export const listHeatingZones = <ThrowOnError extends boolean = false>(
  options?: Options<ListHeatingZonesData, ThrowOnError>,
): RequestResult<ListHeatingZonesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListHeatingZonesResponses, unknown, ThrowOnError>({
    url: "/onboarding/heating/zones",
    ...options,
  });

/**
 * Onboarding Fire Heating Zone
 *
 * Turn a zone's target up so its valve opens (circuit identification).
 */
export const fireHeatingZone = <ThrowOnError extends boolean = false>(
  options: Options<FireHeatingZoneData, ThrowOnError>,
): RequestResult<FireHeatingZoneResponses, FireHeatingZoneErrors, ThrowOnError> =>
  (options.client ?? client).post<FireHeatingZoneResponses, FireHeatingZoneErrors, ThrowOnError>({
    url: "/onboarding/heating/zones/{zone}/fire",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Apply Heating Mapping
 *
 * Apply the circuit→room mapping built in the floor-heating step.
 *
 * Pushes the mapping into Home Assistant over its WebSocket API — an area
 * per room, the zone's climate entity renamed into it — then persists the
 * links (ha_room_id + the Heating device's ha_device_id) on the household.
 */
export const applyHeatingMapping = <ThrowOnError extends boolean = false>(
  options: Options<ApplyHeatingMappingData, ThrowOnError>,
): RequestResult<ApplyHeatingMappingResponses, ApplyHeatingMappingErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ApplyHeatingMappingResponses,
    ApplyHeatingMappingErrors,
    ThrowOnError
  >({
    url: "/onboarding/heating/mapping",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Windows Status
 *
 * Whether Home Assistant has the KLG 300, plus the actuators it exposes.
 *
 * Drives both the connector check and the discovery stage of the windows
 * step. Like the hub check, a not-yet-reachable connector is a normal 200
 * with connected=false so the screen can keep polling.
 */
export const getWindowsStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetWindowsStatusData, ThrowOnError>,
): RequestResult<GetWindowsStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetWindowsStatusResponses, unknown, ThrowOnError>({
    url: "/onboarding/windows/status",
    ...options,
  });

/**
 * Onboarding Rescan Windows
 *
 * Reload the KLG 300 so newly commissioned windows show up.
 *
 * The integration enumerates actuators once during setup, so windows paired
 * onto the gateway after Home Assistant started are invisible until its
 * config entry is reloaded — far cheaper than restarting Home Assistant.
 */
export const rescanWindows = <ThrowOnError extends boolean = false>(
  options?: Options<RescanWindowsData, ThrowOnError>,
): RequestResult<RescanWindowsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<RescanWindowsResponses, unknown, ThrowOnError>({
    url: "/onboarding/windows/rescan",
    ...options,
  });

/**
 * Onboarding Set Window Position
 *
 * Drive one actuator to a position — 25 to nudge it open, 0 to close it.
 *
 * The windows step opens one window at a time so the resident can say which
 * one moved, then closes it again before moving on.
 */
export const setWindowPosition = <ThrowOnError extends boolean = false>(
  options: Options<SetWindowPositionData, ThrowOnError>,
): RequestResult<SetWindowPositionResponses, SetWindowPositionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    SetWindowPositionResponses,
    SetWindowPositionErrors,
    ThrowOnError
  >({
    url: "/onboarding/windows/position",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Apply Window Mapping
 *
 * Apply the actuator→room mapping built in the windows step.
 *
 * Renames each actuator to cover.<room>_cover in its room's Home Assistant
 * area, then persists the binding (ha_device_id / ha_room_id) on the
 * household's window records.
 */
export const applyWindowMapping = <ThrowOnError extends boolean = false>(
  options: Options<ApplyWindowMappingData, ThrowOnError>,
): RequestResult<ApplyWindowMappingResponses, ApplyWindowMappingErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ApplyWindowMappingResponses,
    ApplyWindowMappingErrors,
    ThrowOnError
  >({
    url: "/onboarding/windows/mapping",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Merge Heating Rooms
 *
 * Merge the rooms one thermostat heats into a single room, record and hub.
 *
 * The resident confirmed on the heating step that circuits of one thermostat
 * sit in two or more of their rooms. The Wavin holds one temperature for all
 * of them, so they become one room: the record merges (see room_merge), the
 * thermostat and its area take the merged name, window covers follow, and
 * the surviving sensor's inventory entry is renamed with the room.
 */
export const mergeHeatingRooms = <ThrowOnError extends boolean = false>(
  options: Options<MergeHeatingRoomsData, ThrowOnError>,
): RequestResult<MergeHeatingRoomsResponses, MergeHeatingRoomsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MergeHeatingRoomsResponses,
    MergeHeatingRoomsErrors,
    ThrowOnError
  >({
    url: "/onboarding/heating/merge",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Ventilation State
 *
 * The Nilan-related entities and their live values (ventilation step).
 */
export const getVentilationState = <ThrowOnError extends boolean = false>(
  options?: Options<GetVentilationStateData, ThrowOnError>,
): RequestResult<GetVentilationStateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetVentilationStateResponses, unknown, ThrowOnError>({
    url: "/onboarding/ventilation/state",
    ...options,
  });

/**
 * Onboarding Activate Turbo
 *
 * Put the ventilation unit in boost mode so the user can hear it run.
 */
export const activateTurbo = <ThrowOnError extends boolean = false>(
  options: Options<ActivateTurboData, ThrowOnError>,
): RequestResult<ActivateTurboResponses, ActivateTurboErrors, ThrowOnError> =>
  (options.client ?? client).post<ActivateTurboResponses, ActivateTurboErrors, ThrowOnError>({
    url: "/onboarding/ventilation/turbo",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Air Sensors
 *
 * The AirThings entities and their live values (air-sensors step).
 */
export const listAirSensors = <ThrowOnError extends boolean = false>(
  options?: Options<ListAirSensorsData, ThrowOnError>,
): RequestResult<ListAirSensorsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListAirSensorsResponses, unknown, ThrowOnError>({
    url: "/onboarding/air-sensors",
    ...options,
  });

/**
 * Onboarding Airthings Status
 *
 * AirThings cloud check: is the hub online and every sensor reporting?
 *
 * The sensors talk to the AirThings cloud independently of the Smart Hub,
 * so this reads the household's building there. Problems (unconfigured,
 * cloud unreachable) come back as connected=false with a detail — never an
 * error status — so the connect-hub screen can poll while the user cables
 * the hub.
 */
export const getAirthingsStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetAirthingsStatusData, ThrowOnError>,
): RequestResult<GetAirthingsStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetAirthingsStatusResponses, unknown, ThrowOnError>({
    url: "/onboarding/airthings/status",
    ...options,
  });

/**
 * Admin Upload Household Document
 *
 * Upload a document to a household's storage folder (admin only).
 */
export const adminUploadHouseholdDocument = <ThrowOnError extends boolean = false>(
  options: Options<AdminUploadHouseholdDocumentData, ThrowOnError>,
): RequestResult<
  AdminUploadHouseholdDocumentResponses,
  AdminUploadHouseholdDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminUploadHouseholdDocumentResponses,
    AdminUploadHouseholdDocumentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/admin/households/{household_id}/documents",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Admin Delete Household Document
 *
 * Delete a household document — DB row plus storage object (admin only).
 */
export const adminDeleteHouseholdDocument = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteHouseholdDocumentData, ThrowOnError>,
): RequestResult<
  AdminDeleteHouseholdDocumentResponses,
  AdminDeleteHouseholdDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteHouseholdDocumentResponses,
    AdminDeleteHouseholdDocumentErrors,
    ThrowOnError
  >({ url: "/admin/households/{household_id}/documents/{document_id}", ...options });

/**
 * Onboarding Assistant Photo
 *
 * Store a photo for the assistant to look at, scoped to the household.
 *
 * The path is built from the session's household id and a fresh uuid, never
 * from the client's filename, so a crafted name can't traverse out of this
 * household's folder.
 */
export const uploadAssistantPhoto = <ThrowOnError extends boolean = false>(
  options: Options<UploadAssistantPhotoData, ThrowOnError>,
): RequestResult<UploadAssistantPhotoResponses, UploadAssistantPhotoErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UploadAssistantPhotoResponses,
    UploadAssistantPhotoErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/onboarding/assistant/photo",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Onboarding Assistant Ask
 *
 * Answer a household's setup question, grounded in their live hardware state.
 *
 * Never errors on the model's behalf: with no API key configured, or if OpenAI
 * is unreachable, this returns `available=false` with a support fallback so the
 * sheet can always show something useful.
 */
export const askAssistant = <ThrowOnError extends boolean = false>(
  options: Options<AskAssistantData, ThrowOnError>,
): RequestResult<AskAssistantResponses, AskAssistantErrors, ThrowOnError> =>
  (options.client ?? client).post<AskAssistantResponses, AskAssistantErrors, ThrowOnError>({
    url: "/onboarding/assistant/ask",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Onboarding Assistant Conversation
 *
 * Replay one of the household's own conversations (e.g. after a reload).
 */
export const getAssistantConversation = <ThrowOnError extends boolean = false>(
  options: Options<GetAssistantConversationData, ThrowOnError>,
): RequestResult<GetAssistantConversationResponses, GetAssistantConversationErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetAssistantConversationResponses,
    GetAssistantConversationErrors,
    ThrowOnError
  >({ url: "/onboarding/assistant/conversations/{conversation_id}", ...options });

/**
 * List Issues
 *
 * This household's unreported issues, oldest first.
 */
export const listIssues = <ThrowOnError extends boolean = false>(
  options?: Options<ListIssuesData, ThrowOnError>,
): RequestResult<ListIssuesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListIssuesResponses, unknown, ThrowOnError>({
    url: "/onboarding/issues",
    ...options,
  });

/**
 * Record Issue
 *
 * Record one problem the household hit on a connector step.
 *
 * Upserts on household plus step plus verdict, so a retry loop hitting the
 * same failure repeatedly updates one row instead of spamming new ones. The
 * upsert deliberately leaves `created_at` alone: the report timer is
 * anchored on when a problem was FIRST seen, and refreshing it on every
 * re-record let a household stuck in a retry loop push its own deadline out
 * indefinitely. A recurrence still clears `reported_at`, so a fault that
 * comes back after a report is reported again rather than staying silent.
 * Because `created_at` keeps its original value, a fault that comes back
 * after its report is already past the hour and goes out on the next sweep
 * pass rather than waiting another hour. That is the behaviour we want: the
 * household has now hit the same problem twice.
 *
 * Never depends on the hub being reachable: a household whose hub cannot be
 * reached is exactly when this matters most, so nothing here makes a network
 * call, only the write.
 *
 * `urgent` on the request breaks the "one email at the end" rule for the one
 * case where the rule cannot hold: a step the resident cannot walk past. The
 * hub is the only one today, and `_urgent_send_allowed` decides that here
 * rather than trusting the flag, so a client cannot mail support from any
 * step it likes. A flag the server does not honour is logged and ignored,
 * never rejected: the resident's issue still has to be recorded. The send
 * goes out as a background task rather than being awaited, because it waits
 * on an OpenAI summary and a Resend call and this response is what unblocks
 * the screen the resident is stuck on. It cannot produce a second email: it
 * claims the same batch through the same `_send_issue_report_for_household`,
 * so a later sweep or end-of-flow send reads back nothing to send.
 */
export const recordIssue = <ThrowOnError extends boolean = false>(
  options: Options<RecordIssueData, ThrowOnError>,
): RequestResult<RecordIssueResponses, RecordIssueErrors, ThrowOnError> =>
  (options.client ?? client).post<RecordIssueResponses, RecordIssueErrors, ThrowOnError>({
    url: "/onboarding/issues",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send Issue Report
 *
 * Generate one report from every unreported issue for this household, and send it.
 *
 * Idempotent: with nothing unreported, this is a no-op — `sent=False` with a
 * detail saying so, not an error.
 *
 * Nothing in the app calls this yet: the `requested` trigger it stamps on the
 * report is operator-only until a frontend CTA exists, so a report reading
 * "Requested from the app" today means somebody at VELUX asked for it on the
 * household's behalf. The three triggers that fire by themselves are
 * `end_of_flow`, the sweep's `sweep`, and `urgent` off `recordIssue`.
 */
export const sendIssueReport = <ThrowOnError extends boolean = false>(
  options?: Options<SendIssueReportData, ThrowOnError>,
): RequestResult<SendIssueReportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<SendIssueReportResponses, unknown, ThrowOnError>({
    url: "/onboarding/issues/report",
    ...options,
  });

/**
 * Send Due Issue Reports
 *
 * Run the due-reports sweep now, on demand.
 *
 * The schedule itself lives in this process (see
 * `_start_due_issue_report_loop`), so this endpoint is the manual door onto
 * the same pass: forcing a sweep during support work, and the hook an
 * external cron would use if the backend ever ran on more than one instance.
 * Secret-gated for exactly that reason — it is for a scheduler or an
 * operator with the secret, never for a browser or a household session.
 */
export const sendDueIssueReports = <ThrowOnError extends boolean = false>(
  options?: Options<SendDueIssueReportsData, ThrowOnError>,
): RequestResult<SendDueIssueReportsResponses, SendDueIssueReportsErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    SendDueIssueReportsResponses,
    SendDueIssueReportsErrors,
    ThrowOnError
  >({ url: "/onboarding/issues/report/due", ...options });
